"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PAGE_LIMIT = 25;
var PRODUCT_MAPPINGS_PAGE_ERROR = 'Error getting information about product mappings';
var ADD_MAPPING_ERROR = 'Error occured while adding mapping';
var MAPPING_ALREADEY_EXISTS = 'A mapping for that product already exists';
var INVALID_MAPPING_ERROR = 'Invalid Mapping';
var getBaseFields = function getBaseFields(model) {
  return {
    erpProductCode: {
      kind: !model.erpProductCode ? 'text' : 'static-text',
      label: 'ERP Product Code',
      validations: {
        required: true
      }
    }
  };
};
var getPackageFields = function getPackageFields() {
  return {
    bundleName: {
      kind: 'text',
      label: 'Bundle Name',
      validations: {
        required: true
      }
    },
    packageName: {
      kind: 'list',
      label: 'Package names',
      tooltip: 'These should be package names like "agenda"',
      kind_options: {
        item_kind: 'text'
      },
      validations: {
        required: true
      }
    }
  };
};

// prepare mapping model for the modal
var mappingToModal = function mappingToModal() {
  var mapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var model = _.clone(mapping);
  var fields = getBaseFields(model);
  var titleAction = model.erpProductCode ? 'Edit' : 'Add';
  var titleType;
  if (model.type === 'package') {
    titleType = 'Package Mapping';
    Object.assign(fields, getPackageFields());
  } else {
    titleType = 'Seat Mapping';
  }
  return {
    model: model,
    title: "".concat(titleAction, " ").concat(titleType),
    saveLabel: 'Save',
    fields: fields
  };
};

// from a model from the modal build a mapping
var modalToMapping = function modalToMapping(model, existingMapping) {
  if (existingMapping) {
    model._rev = existingMapping._rev;
  }
  return model;
};
var OrgProductMappings = /*#__PURE__*/function () {
  OrgProductMappings.$inject = ["$rootScope", "$scope", "modalService", "entitlementsService"];
  /* @ngInject */
  function OrgProductMappings($rootScope, $scope, modalService, entitlementsService) {
    _classCallCheck(this, OrgProductMappings);
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.modalService = modalService;
    this.entitlementsService = entitlementsService;
  }

  /**
   * Initializes data
   *
   */
  _createClass(OrgProductMappings, [{
    key: "$onInit",
    value: function $onInit() {
      this.getProductMappings();
    }

    /**
     * Fetches the entitlements product code mappings
     *
     * @param {object} page - The object specifying the pagination
     */
  }, {
    key: "getProductMappings",
    value: function getProductMappings() {
      var _this = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        first: true
      };
      if (this.loading) return;
      this.loading = true;
      return this.entitlementsService.getProductMappings(Object.assign(page, {
        limit: PAGE_LIMIT
      })).then(function (productMappingsPage) {
        // backwards compatibility, previously packageName was string as we could link product code
        // to only a single package, now it is an array
        var _iterator = _createForOfIteratorHelper(productMappingsPage.items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mapping = _step.value;
            var packageName = mapping.packageName;
            mapping.packageName = Array.isArray(packageName) ? packageName : [packageName];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this.productMappingsPage = productMappingsPage;
      }).catch(function (err) {
        console.error(err);
        if (page.first) {
          _this.productMappingsPage = {
            error: PRODUCT_MAPPINGS_PAGE_ERROR
          };
        } else {
          _this.$rootScope.setFlashMessage(PRODUCT_MAPPINGS_PAGE_ERROR, 'danger');
        }
      }).finally(function () {
        _this.loading = false;
      });
    }

    /**
     * Opens a modal with for to allow user to create or edit a mapping, saves the mapping on submit
     */
  }, {
    key: "addMapping",
    value: function addMapping(existingMapping) {
      var _this2 = this;
      this.addMappingLoading = true;
      this.modalService.openModalWithForm(mappingToModal(existingMapping)).then(function (model) {
        (existingMapping.erpProductCode ? _this2.entitlementsService.editProductMapping(modalToMapping(model, existingMapping)) : _this2.entitlementsService.addProductMapping(modalToMapping(model))).then(function (data) {
          if (data.ok) {
            _this2.getProductMappings();
          } else {
            _this2.$rootScope.setFlashMessage(ADD_MAPPING_ERROR, 'danger');
          }
        }).catch(function (err) {
          if (err.data.error === 'MappingAlreadyExists') {
            _this2.$rootScope.setFlashMessage(MAPPING_ALREADEY_EXISTS, 'danger');
          } else if (err.data.error === 'InvalidMappingDocProperties') {
            _this2.$rootScope.setFlashMessage(INVALID_MAPPING_ERROR, 'danger');
          } else {
            _this2.$rootScope.setFlashMessage(ADD_MAPPING_ERROR, 'danger');
          }
        }).finally(function () {
          return _this2.addMappingLoading = false;
        });
      });
    }

    /**
     * Ask for confirmation and then remove the targeted mapping
     * @param {Object} product
     */
  }, {
    key: "removeMapping",
    value: function removeMapping(product) {
      var _this3 = this;
      if (window.confirm("Do you want to remove mapping to ".concat(product.erpProductCode, "? "))) {
        this.entitlementsService.removeProductMapping(product.erpProductCode)
        // refresh
        .then(function () {
          return _this3.getProductMappings();
        });
      }
    }
  }]);
  return OrgProductMappings;
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-product-mappings', ['backstage.services']).component('bsOrgProductMappings', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-product-mappings/org-product-mappings.html',
  controllerAs: 'vm',
  controller: OrgProductMappings
}).name;